import BaseApiService from '../baseApi.service';

export default class AuditLogsMembersService extends BaseApiService {
  readonly basePath: string = 'membership-eventlogs/v1';
  constructor(props = null) {
    super(props);
  }
}
